<ion-item *ngIf="serviceCategories.count() == 0">
  No services
</ion-item>

<ion-list>
  <ion-item-group 
    *ngFor="let serviceCategory of serviceCategories; let serviceCategoryIndex = index;" 
    tappable
    (click)="onServiceCategorySelect(serviceCategoryIndex, serviceCategory, $event)">
    <ion-item-divider color="light" style="font-weight: bold;">{{ serviceCategory.categoryName }}</ion-item-divider>
    <ion-item *ngIf="serviceCategory.serviceDefinitions.size == 0">
      <ion-note>No services</ion-note>
    </ion-item>

    <smr-service-definition
      *ngFor="let serviceDefinition of serviceCategory.getServiceDefinitions(); let serviceDefinitionIndex = index;"
      [serviceDefinition]="serviceDefinition"
      tappable
      (click)="onServiceDefinitionSelect(serviceCategoryIndex, serviceDefinitionIndex, serviceDefinition, $event)"
    >
    </smr-service-definition>
  </ion-item-group>
</ion-list>